var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import classNames from 'classnames';
import omit from 'omit.js';
import React, { forwardRef, memo, useMemo } from 'react';
import Auto from '../Auto';
import Fixed from '../Fixed';
import FlexLayout, { selectorPrefix } from '../FlexLayout';
/**
 * TBLCRLayout
 * @param wrapClassName
 * @param wrapStyle
 * @param tProps
 * @param tSplit
 * @param lProps
 * @param lSplit
 * @param rProps
 * @param cProps
 * @param bProps
 * @param autoWrapProps
 * @param rSplit
 * @param autoInnerProps
 * @param bSplit
 * @param props
 * @param ref
 * @constructor
 */
var TBLCRLayout = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(function (_a, ref) {
  var _b;
  var wrapClassName = _a.wrapClassName,
    wrapStyle = _a.wrapStyle,
    autoWrapProps = _a.autoWrapProps,
    autoInnerProps = _a.autoInnerProps,
    tProps = _a.tProps,
    tSplit = _a.tSplit,
    lProps = _a.lProps,
    lSplit = _a.lSplit,
    rProps = _a.rProps,
    rSplit = _a.rSplit,
    cProps = _a.cProps,
    bProps = _a.bProps,
    bSplit = _a.bSplit,
    props = __rest(_a, ["wrapClassName", "wrapStyle", "autoWrapProps", "autoInnerProps", "tProps", "tSplit", "lProps", "lSplit", "rProps", "rSplit", "cProps", "bProps", "bSplit"]);
  // @ts-ignore
  var TProps = omit(tProps, ['children']);
  // @ts-ignore
  var BProps = omit(bProps, ['children']);
  // @ts-ignore
  var LProps = omit(lProps, ['children']);
  // @ts-ignore
  var RProps = omit(rProps, ['children']);
  // @ts-ignore
  var CProps = omit(cProps, ['children']);
  var classList = useMemo(function () {
    var _a;
    return classNames("".concat(selectorPrefix, "-trblc"), (_a = {}, _a["".concat(selectorPrefix, "-trblc-no-autofix")] = cProps && 'autoFixed' in cProps && !cProps.autoFixed, _a), wrapClassName !== null && wrapClassName !== void 0 ? wrapClassName : '');
  }, [cProps]);
  var autoWrapClassList = useMemo(function () {
    var _a;
    var _b;
    return classNames("".concat(selectorPrefix, "-trblc-auto"), (_a = {}, _a["".concat(selectorPrefix, "-trblc-auto-no-autofix")] = autoWrapProps && 'autoFixed' in autoWrapProps && !autoWrapProps.autoFixed, _a), (_b = autoWrapProps === null || autoWrapProps === void 0 ? void 0 : autoWrapProps.className) !== null && _b !== void 0 ? _b : '');
  }, [autoWrapProps]);
  var autoInnerClassList = useMemo(function () {
    var _a;
    var _b;
    return classNames("".concat(selectorPrefix, "-horizontal-flex-layout"), "".concat(selectorPrefix, "-trblc-auto-inner"), (_a = {}, _a["".concat(selectorPrefix, "-trblc-auto-inner-no-autofix")] = autoInnerProps && 'autoFixed' in autoInnerProps && !autoInnerProps.autoFixed, _a), (_b = autoInnerProps === null || autoInnerProps === void 0 ? void 0 : autoInnerProps.className) !== null && _b !== void 0 ? _b : '');
  }, [autoInnerProps]);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: classList,
    style: wrapStyle !== null && wrapStyle !== void 0 ? wrapStyle : {}
  }, /*#__PURE__*/React.createElement(FlexLayout, __assign({}, props !== null && props !== void 0 ? props : {}, {
    className: classNames("".concat(selectorPrefix, "-tblcr-layout"), (_b = props === null || props === void 0 ? void 0 : props.className) !== null && _b !== void 0 ? _b : ''),
    direction: "vertical"
  }), /*#__PURE__*/React.createElement(Fixed, __assign({
    collapseDirection: "T"
  }, TProps !== null && TProps !== void 0 ? TProps : {}), tProps === null || tProps === void 0 ? void 0 : tProps.children), tSplit, /*#__PURE__*/React.createElement(Auto, __assign({}, autoWrapProps !== null && autoWrapProps !== void 0 ? autoWrapProps : {}, {
    fit: false,
    className: autoWrapClassList
  }), /*#__PURE__*/React.createElement(FlexLayout, __assign({}, autoInnerProps !== null && autoInnerProps !== void 0 ? autoInnerProps : {}, {
    className: autoInnerClassList,
    direction: "horizontal"
  }), /*#__PURE__*/React.createElement(Fixed, __assign({
    collapseDirection: "L"
  }, LProps !== null && LProps !== void 0 ? LProps : {}), lProps === null || lProps === void 0 ? void 0 : lProps.children), lSplit, /*#__PURE__*/React.createElement(Auto, __assign({}, CProps !== null && CProps !== void 0 ? CProps : {}), cProps === null || cProps === void 0 ? void 0 : cProps.children), rSplit, /*#__PURE__*/React.createElement(Fixed, __assign({
    collapseDirection: "R"
  }, RProps !== null && RProps !== void 0 ? RProps : {}), rProps === null || rProps === void 0 ? void 0 : rProps.children))), bSplit, /*#__PURE__*/React.createElement(Fixed, __assign({}, BProps !== null && BProps !== void 0 ? BProps : {}), bProps === null || bProps === void 0 ? void 0 : bProps.children)));
}));
TBLCRLayout.displayName = 'TBLCRLayout';
export default TBLCRLayout;